
import { handleHttpRequest, http, type HttpResponse } from 'interfaces'

export async function deletePosition (orgId: number, positionId: number): Promise<HttpResponse<[]>> {
  return await handleHttpRequest(http.delete(`/api/v1/organizations/${orgId}/positions/${positionId}/`))
}
